"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = exports.InputWrapper = void 0;

var tslib_1 = require("tslib");

var ui_blocks_1 = require("@hopin-team/ui-blocks");

var ui_grid_1 = require("@hopin-team/ui-grid");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");

var ui_symbols_1 = require("@hopin-team/ui-symbols");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var emphasis = ui_blocks_1.TYPOGRAPHY.emphasis;
var SizePadding;

(function (SizePadding) {
  SizePadding[SizePadding["tiny"] = 1] = "tiny";
  SizePadding[SizePadding["small"] = 1] = "small";
  SizePadding[SizePadding["medium"] = 2] = "medium";
  SizePadding[SizePadding["large"] = 3] = "large";
})(SizePadding || (SizePadding = {}));

var makeSizeStyles = function makeSizeStyles(size) {
  return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  padding: 0 ", ";\n"], ["\n  padding: 0 ", ";\n"])), (0, ui_symbols_1.calcSpace)(SizePadding[size]));
};

var Width;

(function (Width) {
  Width[Width["tiny"] = 11] = "tiny";
  Width[Width["small"] = 12] = "small";
  Width[Width["medium"] = 14] = "medium";
  Width[Width["large"] = 18] = "large";
})(Width || (Width = {}));

var makeWidthStyles = function makeWidthStyles(size) {
  return (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  max-width: ", "rem;\n"], ["\n  max-width: ", "rem;\n"])), Width[size]);
};

var makeWithTimeWidthStyles = function makeWithTimeWidthStyles(size) {
  return (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  padding-left: ", ";\n  max-width: ", "rem;\n"], ["\n  padding-left: ", ";\n  max-width: ", "rem;\n"])), (0, ui_symbols_1.calcSpace)(SizePadding[size]), Width[size] + 3);
};

var makeWithRangeWidthStyles = function makeWithRangeWidthStyles(size) {
  return (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  padding-left: ", ";\n  max-width: ", "rem;\n"], ["\n  padding-left: ", ";\n  max-width: ", "rem;\n"])), (0, ui_symbols_1.calcSpace)(SizePadding[size]), Width[size] + 6);
};

exports.InputWrapper = (0, styled_components_1.default)(ui_grid_1.Grid)(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  grid-template-columns: ", ";\n  place-items: center;\n  height: 100%;\n  ", "\n"], ["\n  grid-template-columns: ", ";\n  place-items: center;\n  height: 100%;\n  ", "\n"])), function (_a) {
  var withTime = _a.withTime,
      withRange = _a.withRange;
  return withTime ? '0.7fr 1rem 0.5fr 1rem 0.5fr 0.9fr 0.5fr' : withRange ? '0.7fr 1rem 0.5fr 1rem 0.5fr 1rem 0.7fr 1rem 0.5fr 1rem 0.5fr' : '1.25fr 1rem 1fr 1rem 1fr';
}, function (props) {
  return props.withTime ? (0, ui_helper_props_to_styles_1.makeStyles)(props, 'sizeOption', makeWithTimeWidthStyles) : props.withRange ? (0, ui_helper_props_to_styles_1.makeStyles)(props, 'sizeOption', makeWithRangeWidthStyles) : (0, ui_helper_props_to_styles_1.makeStyles)(props, 'sizeOption', makeWidthStyles);
});
exports.Input = styled_components_1.default.input(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  ", "\n  display: inline-block;\n  height: 100%;\n  width: 100%;\n  appearance: textfield;\n  border: none;\n  outline: none;\n  box-shadow: none;\n  color: ", ";\n  line-height: revert;\n  caret-color: ", ";\n  background: transparent;\n  margin-top: 0.0625rem;\n  margin-bottom: 0.0625rem;\n  text-align: center;\n\n  &:focus {\n    border: none;\n    outline: none;\n    box-shadow: none;\n  }\n\n  ", "\n"], ["\n  ", "\n  display: inline-block;\n  height: 100%;\n  width: 100%;\n  appearance: textfield;\n  border: none;\n  outline: none;\n  box-shadow: none;\n  color: ", ";\n  line-height: revert;\n  caret-color: ", ";\n  background: transparent;\n  margin-top: 0.0625rem;\n  margin-bottom: 0.0625rem;\n  text-align: center;\n\n  &:focus {\n    border: none;\n    outline: none;\n    box-shadow: none;\n  }\n\n  ", "\n"])), emphasis, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.DARK', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.UTILITY.ACTION', theme);
}, function (props) {
  return props.withTime || props.withRange ? 'padding: 0;' : (0, ui_helper_props_to_styles_1.makeStyles)(props, 'sizeOption', makeSizeStyles);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;